"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_arrow_down_style_1 = __importDefault(require("./uicon.arrow.down.style"));
class UiconBullets extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { d: "M12.709 14.949h13.41v1.98h-13.41v-1.98zM12.709 21.821h13.41v1.98h-13.41v-1.98zM12.709 8.198h13.41v1.981h-13.41v-1.98zM5.882 8.198h3.017v1.981H5.882v-1.98zM5.882 14.949h3.017v1.98H5.882v-1.98zM5.882 21.821h3.017v1.98H5.882v-1.98z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconBullets.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconBullets.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_arrow_down_style_1.default)(UiconBullets);
//# sourceMappingURL=uicon.bullets.js.map